/*
 * @Author: JamesWong
 * @Description: 授权店铺英文包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 09:56:04
 */
export default {
  authorizedChannel: 'Authorized Channel',
  deletedStore: 'Deleted Store',
  hint: 'Hint',
  deletedStoreTips: 'This Channel cannot login with POS after deleted，Sure to delete this Channel?',
  cancel: 'Cancel',
  confirmDelete: 'Confirm Delete',
  addChannel: 'Add Channel',
  addAuthorizedChannel: 'Add Authorized Channel',
  order: 'Order',
  storeNumber: 'Store Number',
  storeAbbreviation: 'Store Abbreviation',
  storeFullname: 'Store Full-name',
  confirm: 'Confirm',
  searchAuthorizedChannel: 'Search Authorized Channel',
  searchChannel: 'Search  Unauthorized Channel',
  authorizedChannelDeleted: 'Authorized Channel Deleted!',
  authorizedChannelAdded: 'Authorized Channel Added!',
  '渠道配置中心': 'Configuration Center',
  '下载模版': 'Download Template',
  '导入': 'Import',
  '导入教程': 'Import Tutorial',
  '支持通过本地excel表快速导入渠道,点击': 'Support Import Channels Through Excel File',
  '下载模板': 'Download Template',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': 'Import Data Takes Calues from the Second Row of the First Table',
  '选择全部': 'Select All',
  '共': 'total',
  '条': 'page',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '提示': 'Hint',
  '行导入成功，以下': 'row was imported successfully',
  '行数据导入失败': 'and the following xx row data failed',
  '渠道编号': 'Channel No.',
  '知道了': 'I get it'
}


// WEBPACK FOOTER //
// ./src/i18n/en/channel.js